import { defaultStore } from '@/library/firebase'

export const setReview = async (
  userId,
  serviceId,
  reservationId,
  userName,
  rating,
  comment
) => {
  console.log(userId, serviceId, reservationId, userName, rating, comment)
  // add photographers review
  const reviewAdd = await defaultStore
    .collection('photographers_review')
    .add({
      userId: userId,
      userName: userName,
      createAt: new Date(),
      comment: comment,
      serviceId: serviceId,
      reservationId: reservationId,
      rating: rating
    })
    .then(add => {
      console.log(add)
      return true
    })

  //평가 점수 업데이트
  // 작가의 서비스별 평가를 볼 수 있다.
  // 기존의 평가 점수를 가져온다.
  const serviceUpdate = await defaultStore
    .collection('photographers_service')
    .doc(serviceId)
    .get()
    .then(doc => {
      if (doc.exists) {
        return defaultStore
          .collection('photographers_review')
          .where('serviceId', '==', serviceId)
          .get()
          .then(snap => {
            if (snap.size > 0) {
              return new Promise(resolve => {
                let sum = 0
                snap.forEach(snapDoc => {
                  sum = parseInt(snapDoc.data().rating, 10) + sum
                })
                resolve({ total: sum, count: snap.size })
              }).then(res => {
                console.log('합친 점수 ', res)
                const converting =
                  res.total / res.count > 5 ? 5 : res.total / res.count
                return defaultStore
                  .collection('photographers_service')
                  .doc(serviceId)
                  .update({ rating: converting })
                  .then(() => {
                    return true
                  })
              })
            } else {
              false
            }
          })
      } else {
        false
      }
    })

  // 예약에도 추가 해준다. 그래야 앨범 보기 할때 볼 수 있다.
  const reservationRating = await defaultStore
    .collection('reservations')
    .doc(reservationId)
    .update({ rating: rating })
    .then(() => {
      return true
    })

  console.log('결과 reviewAdd:', reviewAdd)
  console.log('결과 serviceUpdate:', serviceUpdate)
  console.log('결과 reservationRating:', reservationRating)

  if (reviewAdd && serviceUpdate && reservationRating) {
    return true
  } else {
    return false
  }
}

// 리뷰를 가져온다.
export const getReview = serviceId => {
  let result = []
  return new Promise(resolve => {
    defaultStore
      .collection('photographers_review')
      .where('serviceId', '==', serviceId)
      .get()
      .then(snap => {
        snap.forEach(doc => {
          if (doc.exists) {
            const data = doc.data()
            result.push(Object.assign(data, { id: doc.id }))
          }
        })
        resolve(result)
      })
      .catch(e => {
        console.error('get review error', e)
      })
  })
}
